import { render, staticRenderFns } from "./Waiting_test.vue?vue&type=template&id=c821be0e"
import script from "./Waiting_test.vue?vue&type=script&lang=js"
export * from "./Waiting_test.vue?vue&type=script&lang=js"
import style0 from "./Waiting_test.vue?vue&type=style&index=0&id=c821be0e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports